import Grid from "@mui/material/Grid"
import MenuItem from "@mui/material/MenuItem"
import TextField from "@mui/material/TextField"
import PropTypes from "prop-types"

import { getAnswer, questionErrorKey } from "./meetingUtils"

const CHOICE_TYPES = ["dropdown", "yes_no"]
const YES_NO_FALLBACK = [
  { value: "Yes", label: "Yes" },
  { value: "No", label: "No" },
]

function columnsFor(question) {
  if (question.field_type === "long_text") return { xs: 12 }
  if (question.field_type === "number") return { xs: 12, sm: 4 }
  return { xs: 12, sm: 6 }
}

// The booking form's questions, as set up under Meetings > Configuration. Used by
// the admin booking form and the public booking page, so both ask the same thing.
export default function BookingQuestionFields({
  questions,
  form,
  errors,
  onAnswerChange,
}) {
  return (
    <Grid container spacing={2}>
      {questions.map((question) => {
        const error = errors[questionErrorKey(question)]
        const isChoice = CHOICE_TYPES.includes(question.field_type)
        const options =
          question.field_type === "yes_no" && question.options.length === 0
            ? YES_NO_FALLBACK
            : question.options
        return (
          <Grid item key={question.key} {...columnsFor(question)}>
            <TextField
              label={`${question.label}${question.required ? " *" : ""}`}
              size="small"
              fullWidth
              value={getAnswer(form, question)}
              onChange={(event) => onAnswerChange(question, event.target.value)}
              error={Boolean(error)}
              helperText={error || question.help_text || undefined}
              select={isChoice}
              multiline={question.field_type === "long_text"}
              minRows={question.field_type === "long_text" ? 3 : undefined}
            >
              {isChoice
                ? options.map((option) => (
                    <MenuItem key={option.value} value={option.value}>
                      {option.label}
                    </MenuItem>
                  ))
                : null}
            </TextField>
          </Grid>
        )
      })}
    </Grid>
  )
}

BookingQuestionFields.propTypes = {
  questions: PropTypes.arrayOf(
    PropTypes.shape({
      key: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired,
      field_type: PropTypes.string.isRequired,
      required: PropTypes.bool,
      help_text: PropTypes.string,
      options: PropTypes.array,
    })
  ).isRequired,
  form: PropTypes.object.isRequired,
  errors: PropTypes.object.isRequired,
  onAnswerChange: PropTypes.func.isRequired,
}
